import { includes, some, map, get, filter, isEmpty, every, compact } from 'lodash'

const filteredCustomers = ({ customers, filters }) => filter(compact(customers), (customer) => {
  const filterResults = {}

  if (filters.locations != 'All') {
    const locationIds = map(filters.locations, 'value')

    filterResults['locations'] = some(customer.vms, vm => includes(locationIds, get(vm, 'location_id')))
  }

  if (filters.calligoManagement != 'All') {
    filterResults['calligoManagement'] = some(
      customer.vms, vm => vm.calligo_management === filters.calligoManagement
    )
  }

  if (filters.products != 'All') {
    filterResults['products'] = some(map(filters.products, 'value'), productId => customer[productId] != 0)
  }

  if (filters.customers != 'All') {
    filterResults['customers'] = includes(map(filters.customers, 'value'), get(customer, 'customer_id'))
  }

  const hasMatchedFilters = every(filterResults, (value, _key) => value === true)

  return (hasMatchedFilters || isEmpty(filterResults))
})

const filteredVMs = ({ vms = [], filters }) => filter(compact(vms), (vm) => {
  const filterResults = {}

  if (filters.locations != 'All') {
    const locationIds = map(filters.locations, 'value')

    filterResults['locations'] = includes(locationIds, get(vm, 'location_id'))
  }

  if (filters.calligoManagement != 'All') {
    filterResults['calligoManagement'] = vm.calligo_management === filters.calligoManagement
  }

  if (filters.products != 'All') {
    filterResults['products'] = some(map(filters.products, 'value'), productId => vm[productId] != 0)
  }

  return (every(filterResults, (value, _key) => value === true) || isEmpty(filterResults))
})

const tabTitles = [
  { title: 'Exchange', bundle_ids: [107, 109] },
  { title: 'Office', bundle_ids: [110, 111] },
  { title: 'SQL', bundle_ids: [118, 119, 120, 121], licenseTypes: [{ value: 'SAL', label: 'SAL' }, { value: 'CAL', label: 'CAL' }] },
  { title: 'Visio', bundle_ids: [122, 123] },
  { title: 'RDS', bundle_ids: [124] },
]

export { filteredCustomers, filteredVMs, tabTitles }
